import { useMemo } from 'react';
import { Box, Typography, useScreenClass } from '@vp/swan';

function getTimeOfDayGreeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) return 'morning';
    if (hour < 18) return 'afternoon';
    return 'evening';
}

export function LandingHero() {
    const greeting = useMemo(() => getTimeOfDayGreeting(), []);
    const screenClass = useScreenClass();
    const isMobile = screenClass === 'xs';

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {/* Hero graphic — Figma: visible area ~140×116, 12px to heading */}
            <Box>
                <img
                    src="https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/expert_services/Brief/Chat%20Brief/LandingGraphic.png"
                    alt="Design brief illustration"
                    style={{
                        width: isMobile ? '100px' : '140px',
                        height: 'auto',
                    }}
                />
            </Box>

            {/* Heading — Figma: 12px below graphic */}
            <Typography
                as="h1"
                fontSkin="title-headline"
                style={{
                    textAlign: 'center',
                    maxWidth: '434px',
                    margin: `0 0 ${isMobile ? '24px' : '32px'}`,
                }}
            >
                Good {greeting},<br />
                let's build your design brief
            </Typography>
        </Box>
    );
}
